import GallerySidebar from './GallerySidebar';

export default GallerySidebar;
